/**
 * In-memory auth state for the HR portal. The access token lives ONLY here — a
 * module-level closure variable — never in localStorage/sessionStorage, so an
 * XSS payload cannot read a bearer token off web storage (the Phase-2.5 debt).
 * The long-lived refresh token rides in an httpOnly cookie the JS can't see.
 *
 * `session` holds only the NON-sensitive JWT-derived scope (companyId/role/…),
 * which the router guard + HR-scoped reads consult. Plain CommonJS so node:test
 * requires it and the .ts/.vue/.js layers share one singleton instance.
 */

var accessToken; // undefined until login; wiped on logout / failed refresh
var session = null; // { sub, role, companyId, insurerId, employeeId, email }

function setAccessToken(token) {
  accessToken = token ? token : undefined;
}

function getAccessToken() {
  return accessToken;
}

function setSession(next) {
  session = next || null;
}

function getSession() {
  return session;
}

function clearAuth() {
  accessToken = undefined;
  session = null;
}

module.exports = {
  setAccessToken: setAccessToken,
  getAccessToken: getAccessToken,
  setSession: setSession,
  getSession: getSession,
  clearAuth: clearAuth,
};
